<template>
  <div class="dialog-wrap">
    <el-dialog title="分类列表"
               :close-on-click-modal="false"
               :visible.sync="dialogVisible"
               @close="handleClose"
               @open="handleOpen()"
               width="560px">
      <div>
        <div class="create"> <el-button type="primary"
                     @click="handleCreate()"> 创建</el-button></div>

        <el-table :data="results"
                  :header-cell-style="{
          textAlign: 'center',
        }"
                  border>
          <el-table-column type="selection"
                           width="50"
                           fixed="left"
                           align="center"></el-table-column>
          <el-table-column type="index"
                           width="70"
                           label="序号"
                           align="center">
          </el-table-column>

          <el-table-column label="分类名"
                           align="center"
                           show-overflow-tooltip
                           prop="category_name">
          </el-table-column>

          <el-table-column label="内部备注"
                           align="center"
                           show-overflow-tooltip
                           prop="senior_inner_remark">
          </el-table-column>
          <el-table-column fixed="right"
                           label="操作"
                           width="150"
                           align="center">
            <template slot-scope="scope">
              <div class="link-wrap">
                <el-link type="primary"
                         :underline="false"
                         @click="handleToEdit(scope.row)">编辑</el-link>

                <!-- <el-link type="danger"
                       :underline="false"
                       @click="handleToChangeStatus(scope.row.id)">删除</el-link> -->
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination"> <el-pagination background
                         layout="total, prev, pager, next, sizes, jumper"
                         :current-page="Number(query.pageIndex)"
                         :page-sizes="[10, 20, 50, 100, 500]"
                         :page-size="Number(query.pageSize)"
                         :total="Number(pageTotal)"
                         @size-change="handleSizeChange"
                         @current-change="handleCurrentChange"></el-pagination></div>

      </div>

      <div slot="footer"
           class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary"
                   @click="handleSubmit">确 定</el-button>
      </div>
      <createRelevance :visible="createVisible"
                       :concatDetail="concatDetail"
                       @getList="getList"
                       :title="title"
                       :categorId="categorId" />
    </el-dialog>
  </div>
</template>

<script>
import { categoryDetail } from '@/api/senior'
import createRelevance from '@/components/dialog/senior/createRelevance'
export default {
  components: { createRelevance },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    concatDetail: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },
  data() {
    return {
      title: '创建分类',
      createVisible: false,
      dialogVisible: this.visible,
      dataForm: this.concatDetail,
      imgVisible: false,
      dialogImageUrl: '',
      results: [],
      product_type: 1,
      ProductChooseDialog: false,
      pageTotal: 10,
      query: {
        pageIndex: 1,
        pageSize: 10,
      },
      categorId: null,
    }
  },
  watch: {
    visible(val) {
      this.dialogVisible = val
    },
    concatDetail(val) {
      this.dataForm = val
    },
  },
  methods: {
    getList() {
      this.createVisible = false
      this.categorDetails()
    },
    handleClose() {
      this.dataForm = {}
      this.fileList = []
      this.$emit('close')
    },
    handleCreate() {
      this.title = '创建分类'
      this.createVisible = true
    },
    handleOpen() {
      this.$store.dispatch('getAllColleges')
      this.categorDetails()
    },
    handleToEdit(row) {
      this.categorId = row.id
      this.title = '编辑分类'
      this.createVisible = true
    },
    categorDetails() {
      categoryDetail({
        theme_page_id: this.dataForm.id,
      }).then((res) => {
        this.results = res.list
        this.pageTotal = res.count
      })
    },
    handleSizeChange(val) {
      this.query.pageSize = val
      this.categorDetails()
    },
    handleCurrentChange(val) {
      this.query.pageIndex = val
      this.categorDetails()
    },

    handleSubmit() {},
  },
}
</script>

<style lang="less" scoped>
.create {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 20px;
}
.dialog-wrap {
}
/deep/.el-upload {
  width: 122px;
  height: 122px;
  line-height: 122px;
}
/deep/.el-upload-list__item {
  width: 122px;
  height: 122px;
}
.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
